import type { MDXContent } from 'mdx/types';

import Home from 'src/pages/';
import AuthBrowserTokens, {
  tableOfContents as AuthBrowserTokensTableOfContents,
} from 'src/pages/auth/browser-tokens.mdx';
import AuthHirerRelationships, {
  tableOfContents as AuthHirerRelationshipsTableOfContents,
} from 'src/pages/auth/hirer-relationships.mdx';
import AuthPartnerTokens, {
  tableOfContents as AuthPartnerTokensTableOfContents,
} from 'src/pages/auth/partner-tokens.mdx';
import Auth, {
  tableOfContents as AuthTableOfContents,
} from 'src/pages/auth.mdx';
import EventsPolling, {
  tableOfContents as EventsPollingTableOfContents,
} from 'src/pages/events/polling.mdx';
import EventsWebhooks, {
  tableOfContents as EventsWebhooksTableOfContents,
} from 'src/pages/events/webhooks.mdx';
import Events, {
  tableOfContents as EventsTableOfContents,
} from 'src/pages/events.mdx';
import GraphqlErrorResponses, {
  tableOfContents as GraphqlErrorResponsesTableOfContents,
} from 'src/pages/graphql/error-responses.mdx';
import GraphqlInPractice, {
  tableOfContents as GraphqlInPracticeTableOfContents,
} from 'src/pages/graphql/in-practice.mdx';
import GraphqlPlaygroundMockObjects, {
  tableOfContents as GraphqlPlaygroundMockObjectsTableOfContents,
} from 'src/pages/graphql/playground/mock-objects.mdx';
import GraphqlPlayground, {
  tableOfContents as GraphqlPlaygroundTableOfContents,
} from 'src/pages/graphql/playground.mdx';
import GraphqlSeekApiConventions, {
  tableOfContents as GraphqlSeekApiConventionsTableOfContents,
} from 'src/pages/graphql/seek-api-conventions.mdx';
import Graphql, {
  tableOfContents as GraphqlTableOfContents,
} from 'src/pages/graphql.mdx';
import Guides2024RevisionAdPerformance, {
  tableOfContents as Guides2024RevisionAdPerformanceTableOfContents,
} from 'src/pages/guides/2024-revision/ad-performance.mdx';
import Guides2024RevisionApplyWithSeek, {
  tableOfContents as Guides2024RevisionApplyWithSeekTableOfContents,
} from 'src/pages/guides/2024-revision/apply-with-seek.mdx';
import Guides2024RevisionDeveloperDashboard, {
  tableOfContents as Guides2024RevisionDeveloperDashboardTableOfContents,
} from 'src/pages/guides/2024-revision/developer-dashboard.mdx';
import Guides2024RevisionHirerIdentifiers, {
  tableOfContents as Guides2024RevisionHirerIdentifiersTableOfContents,
} from 'src/pages/guides/2024-revision/hirer-identifiers.mdx';
import Guides2024Revision, {
  tableOfContents as Guides2024RevisionTableOfContents,
} from 'src/pages/guides/2024-revision.mdx';
import GuidesMonitoring, {
  tableOfContents as GuidesMonitoringTableOfContents,
} from 'src/pages/guides/monitoring.mdx';
import Guides, {
  tableOfContents as GuidesTableOfContents,
} from 'src/pages/guides.mdx';
import IntroductionBrowserSupport, {
  tableOfContents as IntroductionBrowserSupportTableOfContents,
} from 'src/pages/introduction/browser-support.mdx';
import IntroductionPanels, {
  tableOfContents as IntroductionPanelsTableOfContents,
} from 'src/pages/introduction/panels.mdx';
import IntroductionReleaseNotes from 'src/pages/introduction/release-notes';
import IntroductionWebComponents, {
  tableOfContents as IntroductionWebComponentsTableOfContents,
} from 'src/pages/introduction/web-components.mdx';
import Introduction, {
  tableOfContents as IntroductionTableOfContents,
} from 'src/pages/introduction.mdx';
import MigrationGuidesArchived, {
  tableOfContents as MigrationGuidesArchivedTableOfContents,
} from 'src/pages/migration-guides/archived.mdx';
import MigrationGuidesJobPostingApiPhase1Auth, {
  tableOfContents as MigrationGuidesJobPostingApiPhase1AuthTableOfContents,
} from 'src/pages/migration-guides/job-posting-api/phase-1-auth.mdx';
import MigrationGuidesJobPostingApiPhase2ObjectIdentifiers, {
  tableOfContents as MigrationGuidesJobPostingApiPhase2ObjectIdentifiersTableOfContents,
} from 'src/pages/migration-guides/job-posting-api/phase-2-object-identifiers.mdx';
import MigrationGuidesJobPostingApiPhase3AdSelection, {
  tableOfContents as MigrationGuidesJobPostingApiPhase3AdSelectionTableOfContents,
} from 'src/pages/migration-guides/job-posting-api/phase-3-ad-selection.mdx';
import MigrationGuidesJobPostingApiPhase4ManagingJobAds, {
  tableOfContents as MigrationGuidesJobPostingApiPhase4ManagingJobAdsTableOfContents,
} from 'src/pages/migration-guides/job-posting-api/phase-4-managing-job-ads.mdx';
import MigrationGuidesJobPostingApiPhase5EventDelivery, {
  tableOfContents as MigrationGuidesJobPostingApiPhase5EventDeliveryTableOfContents,
} from 'src/pages/migration-guides/job-posting-api/phase-5-event-delivery.mdx';
import MigrationGuidesJobPostingApi, {
  tableOfContents as MigrationGuidesJobPostingApiTableOfContents,
} from 'src/pages/migration-guides/job-posting-api.mdx';
import MigrationGuidesJobstreetAndJobsdbUpliftPhase1DeveloperDashboard, {
  tableOfContents as MigrationGuidesJobstreetAndJobsdbUpliftPhase1DeveloperDashboardTableOfContents,
} from 'src/pages/migration-guides/jobstreet-and-jobsdb-uplift/phase-1-developer-dashboard.mdx';
import MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingAdSelectionGraphqlUserExperienceGuide, {
  tableOfContents as MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingAdSelectionGraphqlUserExperienceGuideTableOfContents,
} from 'src/pages/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/ad-selection/graphql/user-experience-guide.mdx';
import MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingAdSelectionGraphql, {
  tableOfContents as MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingAdSelectionGraphqlTableOfContents,
} from 'src/pages/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/ad-selection/graphql.mdx';
import MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingAdSelectionPanel, {
  tableOfContents as MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingAdSelectionPanelTableOfContents,
} from 'src/pages/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/ad-selection/panel.mdx';
import MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingAdSelection, {
  tableOfContents as MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingAdSelectionTableOfContents,
} from 'src/pages/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/ad-selection.mdx';
import MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingBranding, {
  tableOfContents as MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingBrandingTableOfContents,
} from 'src/pages/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/branding.mdx';
import MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingContentLocalisation, {
  tableOfContents as MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingContentLocalisationTableOfContents,
} from 'src/pages/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/content-localisation.mdx';
import MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingJobAdPreview, {
  tableOfContents as MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingJobAdPreviewTableOfContents,
} from 'src/pages/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/job-ad-preview.mdx';
import MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingJobCategories, {
  tableOfContents as MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingJobCategoriesTableOfContents,
} from 'src/pages/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/job-categories.mdx';
import MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingLocations, {
  tableOfContents as MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingLocationsTableOfContents,
} from 'src/pages/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/locations.mdx';
import MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingQuestionnaires, {
  tableOfContents as MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingQuestionnairesTableOfContents,
} from 'src/pages/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/questionnaires.mdx';
import MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingSalary, {
  tableOfContents as MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingSalaryTableOfContents,
} from 'src/pages/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/salary.mdx';
import MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPosting, {
  tableOfContents as MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingTableOfContents,
} from 'src/pages/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting.mdx';
import MigrationGuidesJobstreetAndJobsdbUpliftPhase3ApplyAndProactiveSourcing, {
  tableOfContents as MigrationGuidesJobstreetAndJobsdbUpliftPhase3ApplyAndProactiveSourcingTableOfContents,
} from 'src/pages/migration-guides/jobstreet-and-jobsdb-uplift/phase-3-apply-and-proactive-sourcing.mdx';
import MigrationGuidesJobstreetAndJobsdbUpliftPhase4TransitioningHirers, {
  tableOfContents as MigrationGuidesJobstreetAndJobsdbUpliftPhase4TransitioningHirersTableOfContents,
} from 'src/pages/migration-guides/jobstreet-and-jobsdb-uplift/phase-4-transitioning-hirers.mdx';
import MigrationGuidesJobstreetAndJobsdbUplift, {
  tableOfContents as MigrationGuidesJobstreetAndJobsdbUpliftTableOfContents,
} from 'src/pages/migration-guides/jobstreet-and-jobsdb-uplift.mdx';
import MigrationGuidesOverview, {
  tableOfContents as MigrationGuidesOverviewTableOfContents,
} from 'src/pages/migration-guides/overview.mdx';
import MigrationGuidesSae, {
  tableOfContents as MigrationGuidesSaeTableOfContents,
} from 'src/pages/migration-guides/sae.mdx';
import MigrationGuidesSeekAdvertiserIds, {
  tableOfContents as MigrationGuidesSeekAdvertiserIdsTableOfContents,
} from 'src/pages/migration-guides/seek-advertiser-ids.mdx';
import UseCasesAdPerformanceApplicationCompleteSignal, {
  tableOfContents as UseCasesAdPerformanceApplicationCompleteSignalTableOfContents,
} from 'src/pages/use-cases/ad-performance/application-complete-signal.mdx';
import UseCasesAdPerformancePanel, {
  tableOfContents as UseCasesAdPerformancePanelTableOfContents,
} from 'src/pages/use-cases/ad-performance/panel.mdx';
import UseCasesAdPerformance, {
  tableOfContents as UseCasesAdPerformanceTableOfContents,
} from 'src/pages/use-cases/ad-performance.mdx';
import UseCasesApplicationExportAttachments, {
  tableOfContents as UseCasesApplicationExportAttachmentsTableOfContents,
} from 'src/pages/use-cases/application-export/attachments.mdx';
import UseCasesApplicationExportCandidateProfiles, {
  tableOfContents as UseCasesApplicationExportCandidateProfilesTableOfContents,
} from 'src/pages/use-cases/application-export/candidate-profiles.mdx';
import UseCasesApplicationExportQuestionnaireSubmissions, {
  tableOfContents as UseCasesApplicationExportQuestionnaireSubmissionsTableOfContents,
} from 'src/pages/use-cases/application-export/questionnaire-submissions.mdx';
import UseCasesApplicationExportUserExperienceGuide, {
  tableOfContents as UseCasesApplicationExportUserExperienceGuideTableOfContents,
} from 'src/pages/use-cases/application-export/user-experience-guide.mdx';
import UseCasesApplicationExport, {
  tableOfContents as UseCasesApplicationExportTableOfContents,
} from 'src/pages/use-cases/application-export.mdx';
import UseCasesApplyWithSeekDisplayButton, {
  tableOfContents as UseCasesApplyWithSeekDisplayButtonTableOfContents,
} from 'src/pages/use-cases/apply-with-seek/display-button.mdx';
import UseCasesApplyWithSeekDownloadResume, {
  tableOfContents as UseCasesApplyWithSeekDownloadResumeTableOfContents,
} from 'src/pages/use-cases/apply-with-seek/download-resume.mdx';
import UseCasesApplyWithSeekHandleAuthorization, {
  tableOfContents as UseCasesApplyWithSeekHandleAuthorizationTableOfContents,
} from 'src/pages/use-cases/apply-with-seek/handle-authorization.mdx';
import UseCasesApplyWithSeekPopulateForm, {
  tableOfContents as UseCasesApplyWithSeekPopulateFormTableOfContents,
} from 'src/pages/use-cases/apply-with-seek/populate-form.mdx';
import UseCasesApplyWithSeekRetrieveSeekProfile, {
  tableOfContents as UseCasesApplyWithSeekRetrieveSeekProfileTableOfContents,
} from 'src/pages/use-cases/apply-with-seek/retrieve-seek-profile.mdx';
import UseCasesApplyWithSeekSendApplicationCompleteSignal, {
  tableOfContents as UseCasesApplyWithSeekSendApplicationCompleteSignalTableOfContents,
} from 'src/pages/use-cases/apply-with-seek/send-application-complete-signal.mdx';
import UseCasesApplyWithSeek, {
  tableOfContents as UseCasesApplyWithSeekTableOfContents,
} from 'src/pages/use-cases/apply-with-seek.mdx';
import UseCasesJobPostingAdSelectionGraphql, {
  tableOfContents as UseCasesJobPostingAdSelectionGraphqlTableOfContents,
} from 'src/pages/use-cases/job-posting/ad-selection/graphql.mdx';
import UseCasesJobPostingAdSelectionPanel, {
  tableOfContents as UseCasesJobPostingAdSelectionPanelTableOfContents,
} from 'src/pages/use-cases/job-posting/ad-selection/panel.mdx';
import UseCasesJobPostingAdSelectionV2Features, {
  tableOfContents as UseCasesJobPostingAdSelectionV2FeaturesTableOfContents,
} from 'src/pages/use-cases/job-posting/ad-selection/v2/features.mdx';
import UseCasesJobPostingAdSelectionV2Graphql, {
  tableOfContents as UseCasesJobPostingAdSelectionV2GraphqlTableOfContents,
} from 'src/pages/use-cases/job-posting/ad-selection/v2/graphql.mdx';
import UseCasesJobPostingAdSelectionV2Panel, {
  tableOfContents as UseCasesJobPostingAdSelectionV2PanelTableOfContents,
} from 'src/pages/use-cases/job-posting/ad-selection/v2/panel.mdx';
import UseCasesJobPostingAdSelectionV2Testing, {
  tableOfContents as UseCasesJobPostingAdSelectionV2TestingTableOfContents,
} from 'src/pages/use-cases/job-posting/ad-selection/v2/testing.mdx';
import UseCasesJobPostingAdSelection, {
  tableOfContents as UseCasesJobPostingAdSelectionTableOfContents,
} from 'src/pages/use-cases/job-posting/ad-selection.mdx';
import UseCasesJobPostingApplicationMethods, {
  tableOfContents as UseCasesJobPostingApplicationMethodsTableOfContents,
} from 'src/pages/use-cases/job-posting/application-methods.mdx';
import UseCasesJobPostingArchivedAdSelection, {
  tableOfContents as UseCasesJobPostingArchivedAdSelectionTableOfContents,
} from 'src/pages/use-cases/job-posting/archived/ad-selection.mdx';
import UseCasesJobPostingArchivedQuestionnaires, {
  tableOfContents as UseCasesJobPostingArchivedQuestionnairesTableOfContents,
} from 'src/pages/use-cases/job-posting/archived/questionnaires.mdx';
import UseCasesJobPostingArchived, {
  tableOfContents as UseCasesJobPostingArchivedTableOfContents,
} from 'src/pages/use-cases/job-posting/archived.mdx';
import UseCasesJobPostingBranding, {
  tableOfContents as UseCasesJobPostingBrandingTableOfContents,
} from 'src/pages/use-cases/job-posting/branding.mdx';
import UseCasesJobPostingContactPeople, {
  tableOfContents as UseCasesJobPostingContactPeopleTableOfContents,
} from 'src/pages/use-cases/job-posting/contact-people.mdx';
import UseCasesJobPostingFeatures, {
  tableOfContents as UseCasesJobPostingFeaturesTableOfContents,
} from 'src/pages/use-cases/job-posting/features.mdx';
import UseCasesJobPostingIdentifiersAndReferences, {
  tableOfContents as UseCasesJobPostingIdentifiersAndReferencesTableOfContents,
} from 'src/pages/use-cases/job-posting/identifiers-and-references.mdx';
import UseCasesJobPostingJobCategories, {
  tableOfContents as UseCasesJobPostingJobCategoriesTableOfContents,
} from 'src/pages/use-cases/job-posting/job-categories.mdx';
import UseCasesJobPostingLocations, {
  tableOfContents as UseCasesJobPostingLocationsTableOfContents,
} from 'src/pages/use-cases/job-posting/locations.mdx';
import UseCasesJobPostingManagingJobAdsClosingAJobAd, {
  tableOfContents as UseCasesJobPostingManagingJobAdsClosingAJobAdTableOfContents,
} from 'src/pages/use-cases/job-posting/managing-job-ads/closing-a-job-ad.mdx';
import UseCasesJobPostingManagingJobAdsPostingAJobAd, {
  tableOfContents as UseCasesJobPostingManagingJobAdsPostingAJobAdTableOfContents,
} from 'src/pages/use-cases/job-posting/managing-job-ads/posting-a-job-ad.mdx';
import UseCasesJobPostingManagingJobAdsPreviewingAJobAd, {
  tableOfContents as UseCasesJobPostingManagingJobAdsPreviewingAJobAdTableOfContents,
} from 'src/pages/use-cases/job-posting/managing-job-ads/previewing-a-job-ad.mdx';
import UseCasesJobPostingManagingJobAdsQueryingAJobAd, {
  tableOfContents as UseCasesJobPostingManagingJobAdsQueryingAJobAdTableOfContents,
} from 'src/pages/use-cases/job-posting/managing-job-ads/querying-a-job-ad.mdx';
import UseCasesJobPostingManagingJobAdsUpdatingAJobAd, {
  tableOfContents as UseCasesJobPostingManagingJobAdsUpdatingAJobAdTableOfContents,
} from 'src/pages/use-cases/job-posting/managing-job-ads/updating-a-job-ad.mdx';
import UseCasesJobPostingManagingJobAds, {
  tableOfContents as UseCasesJobPostingManagingJobAdsTableOfContents,
} from 'src/pages/use-cases/job-posting/managing-job-ads.mdx';
import UseCasesJobPostingPositionOpenings, {
  tableOfContents as UseCasesJobPostingPositionOpeningsTableOfContents,
} from 'src/pages/use-cases/job-posting/position-openings.mdx';
import UseCasesJobPostingQuestionnairesAtsQuestions, {
  tableOfContents as UseCasesJobPostingQuestionnairesAtsQuestionsTableOfContents,
} from 'src/pages/use-cases/job-posting/questionnaires/ats-questions.mdx';
import UseCasesJobPostingQuestionnairesCustomPanel, {
  tableOfContents as UseCasesJobPostingQuestionnairesCustomPanelTableOfContents,
} from 'src/pages/use-cases/job-posting/questionnaires/custom-panel.mdx';
import UseCasesJobPostingQuestionnairesPanel, {
  tableOfContents as UseCasesJobPostingQuestionnairesPanelTableOfContents,
} from 'src/pages/use-cases/job-posting/questionnaires/panel.mdx';
import UseCasesJobPostingQuestionnairesV2Panel, {
  tableOfContents as UseCasesJobPostingQuestionnairesV2PanelTableOfContents,
} from 'src/pages/use-cases/job-posting/questionnaires/v2/panel.mdx';
import UseCasesJobPostingQuestionnaires, {
  tableOfContents as UseCasesJobPostingQuestionnairesTableOfContents,
} from 'src/pages/use-cases/job-posting/questionnaires.mdx';
import UseCasesJobPostingReflectingJobAds, {
  tableOfContents as UseCasesJobPostingReflectingJobAdsTableOfContents,
} from 'src/pages/use-cases/job-posting/reflecting-job-ads.mdx';
import UseCasesJobPostingSalary, {
  tableOfContents as UseCasesJobPostingSalaryTableOfContents,
} from 'src/pages/use-cases/job-posting/salary.mdx';
import UseCasesJobPostingUserExperienceGuide, {
  tableOfContents as UseCasesJobPostingUserExperienceGuideTableOfContents,
} from 'src/pages/use-cases/job-posting/user-experience-guide.mdx';
import UseCasesJobPosting, {
  tableOfContents as UseCasesJobPostingTableOfContents,
} from 'src/pages/use-cases/job-posting.mdx';
import UseCasesProactiveSourcingInteractionHistory, {
  tableOfContents as UseCasesProactiveSourcingInteractionHistoryTableOfContents,
} from 'src/pages/use-cases/proactive-sourcing/interaction-history.mdx';
import UseCasesProactiveSourcingProfilePurchases, {
  tableOfContents as UseCasesProactiveSourcingProfilePurchasesTableOfContents,
} from 'src/pages/use-cases/proactive-sourcing/profile-purchases.mdx';
import UseCasesProactiveSourcingSharingACandidate, {
  tableOfContents as UseCasesProactiveSourcingSharingACandidateTableOfContents,
} from 'src/pages/use-cases/proactive-sourcing/sharing-a-candidate.mdx';
import UseCasesProactiveSourcingUnpostedPositions, {
  tableOfContents as UseCasesProactiveSourcingUnpostedPositionsTableOfContents,
} from 'src/pages/use-cases/proactive-sourcing/unposted-positions.mdx';
import UseCasesProactiveSourcingWidgets, {
  tableOfContents as UseCasesProactiveSourcingWidgetsTableOfContents,
} from 'src/pages/use-cases/proactive-sourcing/widgets.mdx';
import UseCasesProactiveSourcing, {
  tableOfContents as UseCasesProactiveSourcingTableOfContents,
} from 'src/pages/use-cases/proactive-sourcing.mdx';
import UseCasesTestCases, {
  tableOfContents as UseCasesTestCasesTableOfContents,
} from 'src/pages/use-cases/test-cases.mdx';

import type { TableOfContents, TemplateComponent } from './types';

export const mdxDocuments: Record<
  string,
  { toc: TableOfContents[]; document: MDXContent }
> = {
  '/auth/browser-tokens': {
    toc: AuthBrowserTokensTableOfContents,
    document: AuthBrowserTokens,
  },
  '/auth/hirer-relationships': {
    toc: AuthHirerRelationshipsTableOfContents,
    document: AuthHirerRelationships,
  },
  '/auth/partner-tokens': {
    toc: AuthPartnerTokensTableOfContents,
    document: AuthPartnerTokens,
  },
  '/auth': { toc: AuthTableOfContents, document: Auth },
  '/events/polling': {
    toc: EventsPollingTableOfContents,
    document: EventsPolling,
  },
  '/events/webhooks': {
    toc: EventsWebhooksTableOfContents,
    document: EventsWebhooks,
  },
  '/events': { toc: EventsTableOfContents, document: Events },
  '/graphql/error-responses': {
    toc: GraphqlErrorResponsesTableOfContents,
    document: GraphqlErrorResponses,
  },
  '/graphql/in-practice': {
    toc: GraphqlInPracticeTableOfContents,
    document: GraphqlInPractice,
  },
  '/graphql/playground/mock-objects': {
    toc: GraphqlPlaygroundMockObjectsTableOfContents,
    document: GraphqlPlaygroundMockObjects,
  },
  '/graphql/playground': {
    toc: GraphqlPlaygroundTableOfContents,
    document: GraphqlPlayground,
  },
  '/graphql/seek-api-conventions': {
    toc: GraphqlSeekApiConventionsTableOfContents,
    document: GraphqlSeekApiConventions,
  },
  '/graphql': { toc: GraphqlTableOfContents, document: Graphql },
  '/guides/2024-revision/ad-performance': {
    toc: Guides2024RevisionAdPerformanceTableOfContents,
    document: Guides2024RevisionAdPerformance,
  },
  '/guides/2024-revision/apply-with-seek': {
    toc: Guides2024RevisionApplyWithSeekTableOfContents,
    document: Guides2024RevisionApplyWithSeek,
  },
  '/guides/2024-revision/developer-dashboard': {
    toc: Guides2024RevisionDeveloperDashboardTableOfContents,
    document: Guides2024RevisionDeveloperDashboard,
  },
  '/guides/2024-revision/hirer-identifiers': {
    toc: Guides2024RevisionHirerIdentifiersTableOfContents,
    document: Guides2024RevisionHirerIdentifiers,
  },
  '/guides/2024-revision': {
    toc: Guides2024RevisionTableOfContents,
    document: Guides2024Revision,
  },
  '/guides/monitoring': {
    toc: GuidesMonitoringTableOfContents,
    document: GuidesMonitoring,
  },
  '/guides': { toc: GuidesTableOfContents, document: Guides },
  '/introduction/browser-support': {
    toc: IntroductionBrowserSupportTableOfContents,
    document: IntroductionBrowserSupport,
  },
  '/introduction/panels': {
    toc: IntroductionPanelsTableOfContents,
    document: IntroductionPanels,
  },
  '/introduction/web-components': {
    toc: IntroductionWebComponentsTableOfContents,
    document: IntroductionWebComponents,
  },
  '/introduction': { toc: IntroductionTableOfContents, document: Introduction },
  '/migration-guides/archived': {
    toc: MigrationGuidesArchivedTableOfContents,
    document: MigrationGuidesArchived,
  },
  '/migration-guides/job-posting-api/phase-1-auth': {
    toc: MigrationGuidesJobPostingApiPhase1AuthTableOfContents,
    document: MigrationGuidesJobPostingApiPhase1Auth,
  },
  '/migration-guides/job-posting-api/phase-2-object-identifiers': {
    toc: MigrationGuidesJobPostingApiPhase2ObjectIdentifiersTableOfContents,
    document: MigrationGuidesJobPostingApiPhase2ObjectIdentifiers,
  },
  '/migration-guides/job-posting-api/phase-3-ad-selection': {
    toc: MigrationGuidesJobPostingApiPhase3AdSelectionTableOfContents,
    document: MigrationGuidesJobPostingApiPhase3AdSelection,
  },
  '/migration-guides/job-posting-api/phase-4-managing-job-ads': {
    toc: MigrationGuidesJobPostingApiPhase4ManagingJobAdsTableOfContents,
    document: MigrationGuidesJobPostingApiPhase4ManagingJobAds,
  },
  '/migration-guides/job-posting-api/phase-5-event-delivery': {
    toc: MigrationGuidesJobPostingApiPhase5EventDeliveryTableOfContents,
    document: MigrationGuidesJobPostingApiPhase5EventDelivery,
  },
  '/migration-guides/job-posting-api': {
    toc: MigrationGuidesJobPostingApiTableOfContents,
    document: MigrationGuidesJobPostingApi,
  },
  '/migration-guides/jobstreet-and-jobsdb-uplift/phase-1-developer-dashboard': {
    toc: MigrationGuidesJobstreetAndJobsdbUpliftPhase1DeveloperDashboardTableOfContents,
    document: MigrationGuidesJobstreetAndJobsdbUpliftPhase1DeveloperDashboard,
  },
  '/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/ad-selection/graphql/user-experience-guide':
    {
      toc: MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingAdSelectionGraphqlUserExperienceGuideTableOfContents,
      document:
        MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingAdSelectionGraphqlUserExperienceGuide,
    },
  '/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/ad-selection/graphql':
    {
      toc: MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingAdSelectionGraphqlTableOfContents,
      document:
        MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingAdSelectionGraphql,
    },
  '/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/ad-selection/panel':
    {
      toc: MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingAdSelectionPanelTableOfContents,
      document:
        MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingAdSelectionPanel,
    },
  '/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/ad-selection':
    {
      toc: MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingAdSelectionTableOfContents,
      document:
        MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingAdSelection,
    },
  '/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/branding':
    {
      toc: MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingBrandingTableOfContents,
      document: MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingBranding,
    },
  '/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/content-localisation':
    {
      toc: MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingContentLocalisationTableOfContents,
      document:
        MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingContentLocalisation,
    },
  '/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/job-ad-preview':
    {
      toc: MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingJobAdPreviewTableOfContents,
      document:
        MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingJobAdPreview,
    },
  '/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/job-categories':
    {
      toc: MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingJobCategoriesTableOfContents,
      document:
        MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingJobCategories,
    },
  '/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/locations':
    {
      toc: MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingLocationsTableOfContents,
      document:
        MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingLocations,
    },
  '/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/questionnaires':
    {
      toc: MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingQuestionnairesTableOfContents,
      document:
        MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingQuestionnaires,
    },
  '/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/salary': {
    toc: MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingSalaryTableOfContents,
    document: MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingSalary,
  },
  '/migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting': {
    toc: MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPostingTableOfContents,
    document: MigrationGuidesJobstreetAndJobsdbUpliftPhase2JobPosting,
  },
  '/migration-guides/jobstreet-and-jobsdb-uplift/phase-3-apply-and-proactive-sourcing':
    {
      toc: MigrationGuidesJobstreetAndJobsdbUpliftPhase3ApplyAndProactiveSourcingTableOfContents,
      document:
        MigrationGuidesJobstreetAndJobsdbUpliftPhase3ApplyAndProactiveSourcing,
    },
  '/migration-guides/jobstreet-and-jobsdb-uplift/phase-4-transitioning-hirers':
    {
      toc: MigrationGuidesJobstreetAndJobsdbUpliftPhase4TransitioningHirersTableOfContents,
      document:
        MigrationGuidesJobstreetAndJobsdbUpliftPhase4TransitioningHirers,
    },
  '/migration-guides/jobstreet-and-jobsdb-uplift': {
    toc: MigrationGuidesJobstreetAndJobsdbUpliftTableOfContents,
    document: MigrationGuidesJobstreetAndJobsdbUplift,
  },
  '/migration-guides/overview': {
    toc: MigrationGuidesOverviewTableOfContents,
    document: MigrationGuidesOverview,
  },
  '/migration-guides/sae': {
    toc: MigrationGuidesSaeTableOfContents,
    document: MigrationGuidesSae,
  },
  '/migration-guides/seek-advertiser-ids': {
    toc: MigrationGuidesSeekAdvertiserIdsTableOfContents,
    document: MigrationGuidesSeekAdvertiserIds,
  },
  '/use-cases/ad-performance/application-complete-signal': {
    toc: UseCasesAdPerformanceApplicationCompleteSignalTableOfContents,
    document: UseCasesAdPerformanceApplicationCompleteSignal,
  },
  '/use-cases/ad-performance/panel': {
    toc: UseCasesAdPerformancePanelTableOfContents,
    document: UseCasesAdPerformancePanel,
  },
  '/use-cases/ad-performance': {
    toc: UseCasesAdPerformanceTableOfContents,
    document: UseCasesAdPerformance,
  },
  '/use-cases/application-export/attachments': {
    toc: UseCasesApplicationExportAttachmentsTableOfContents,
    document: UseCasesApplicationExportAttachments,
  },
  '/use-cases/application-export/candidate-profiles': {
    toc: UseCasesApplicationExportCandidateProfilesTableOfContents,
    document: UseCasesApplicationExportCandidateProfiles,
  },
  '/use-cases/application-export/questionnaire-submissions': {
    toc: UseCasesApplicationExportQuestionnaireSubmissionsTableOfContents,
    document: UseCasesApplicationExportQuestionnaireSubmissions,
  },
  '/use-cases/application-export/user-experience-guide': {
    toc: UseCasesApplicationExportUserExperienceGuideTableOfContents,
    document: UseCasesApplicationExportUserExperienceGuide,
  },
  '/use-cases/application-export': {
    toc: UseCasesApplicationExportTableOfContents,
    document: UseCasesApplicationExport,
  },
  '/use-cases/apply-with-seek/display-button': {
    toc: UseCasesApplyWithSeekDisplayButtonTableOfContents,
    document: UseCasesApplyWithSeekDisplayButton,
  },
  '/use-cases/apply-with-seek/download-resume': {
    toc: UseCasesApplyWithSeekDownloadResumeTableOfContents,
    document: UseCasesApplyWithSeekDownloadResume,
  },
  '/use-cases/apply-with-seek/handle-authorization': {
    toc: UseCasesApplyWithSeekHandleAuthorizationTableOfContents,
    document: UseCasesApplyWithSeekHandleAuthorization,
  },
  '/use-cases/apply-with-seek/populate-form': {
    toc: UseCasesApplyWithSeekPopulateFormTableOfContents,
    document: UseCasesApplyWithSeekPopulateForm,
  },
  '/use-cases/apply-with-seek/retrieve-seek-profile': {
    toc: UseCasesApplyWithSeekRetrieveSeekProfileTableOfContents,
    document: UseCasesApplyWithSeekRetrieveSeekProfile,
  },
  '/use-cases/apply-with-seek/send-application-complete-signal': {
    toc: UseCasesApplyWithSeekSendApplicationCompleteSignalTableOfContents,
    document: UseCasesApplyWithSeekSendApplicationCompleteSignal,
  },
  '/use-cases/apply-with-seek': {
    toc: UseCasesApplyWithSeekTableOfContents,
    document: UseCasesApplyWithSeek,
  },
  '/use-cases/job-posting/ad-selection/graphql': {
    toc: UseCasesJobPostingAdSelectionGraphqlTableOfContents,
    document: UseCasesJobPostingAdSelectionGraphql,
  },
  '/use-cases/job-posting/ad-selection/panel': {
    toc: UseCasesJobPostingAdSelectionPanelTableOfContents,
    document: UseCasesJobPostingAdSelectionPanel,
  },
  '/use-cases/job-posting/ad-selection/v2/features': {
    toc: UseCasesJobPostingAdSelectionV2FeaturesTableOfContents,
    document: UseCasesJobPostingAdSelectionV2Features,
  },
  '/use-cases/job-posting/ad-selection/v2/graphql': {
    toc: UseCasesJobPostingAdSelectionV2GraphqlTableOfContents,
    document: UseCasesJobPostingAdSelectionV2Graphql,
  },
  '/use-cases/job-posting/ad-selection/v2/panel': {
    toc: UseCasesJobPostingAdSelectionV2PanelTableOfContents,
    document: UseCasesJobPostingAdSelectionV2Panel,
  },
  '/use-cases/job-posting/ad-selection/v2/testing': {
    toc: UseCasesJobPostingAdSelectionV2TestingTableOfContents,
    document: UseCasesJobPostingAdSelectionV2Testing,
  },
  '/use-cases/job-posting/ad-selection': {
    toc: UseCasesJobPostingAdSelectionTableOfContents,
    document: UseCasesJobPostingAdSelection,
  },
  '/use-cases/job-posting/application-methods': {
    toc: UseCasesJobPostingApplicationMethodsTableOfContents,
    document: UseCasesJobPostingApplicationMethods,
  },
  '/use-cases/job-posting/archived/ad-selection': {
    toc: UseCasesJobPostingArchivedAdSelectionTableOfContents,
    document: UseCasesJobPostingArchivedAdSelection,
  },
  '/use-cases/job-posting/archived/questionnaires': {
    toc: UseCasesJobPostingArchivedQuestionnairesTableOfContents,
    document: UseCasesJobPostingArchivedQuestionnaires,
  },
  '/use-cases/job-posting/archived': {
    toc: UseCasesJobPostingArchivedTableOfContents,
    document: UseCasesJobPostingArchived,
  },
  '/use-cases/job-posting/branding': {
    toc: UseCasesJobPostingBrandingTableOfContents,
    document: UseCasesJobPostingBranding,
  },
  '/use-cases/job-posting/contact-people': {
    toc: UseCasesJobPostingContactPeopleTableOfContents,
    document: UseCasesJobPostingContactPeople,
  },
  '/use-cases/job-posting/features': {
    toc: UseCasesJobPostingFeaturesTableOfContents,
    document: UseCasesJobPostingFeatures,
  },
  '/use-cases/job-posting/identifiers-and-references': {
    toc: UseCasesJobPostingIdentifiersAndReferencesTableOfContents,
    document: UseCasesJobPostingIdentifiersAndReferences,
  },
  '/use-cases/job-posting/job-categories': {
    toc: UseCasesJobPostingJobCategoriesTableOfContents,
    document: UseCasesJobPostingJobCategories,
  },
  '/use-cases/job-posting/locations': {
    toc: UseCasesJobPostingLocationsTableOfContents,
    document: UseCasesJobPostingLocations,
  },
  '/use-cases/job-posting/managing-job-ads/closing-a-job-ad': {
    toc: UseCasesJobPostingManagingJobAdsClosingAJobAdTableOfContents,
    document: UseCasesJobPostingManagingJobAdsClosingAJobAd,
  },
  '/use-cases/job-posting/managing-job-ads/posting-a-job-ad': {
    toc: UseCasesJobPostingManagingJobAdsPostingAJobAdTableOfContents,
    document: UseCasesJobPostingManagingJobAdsPostingAJobAd,
  },
  '/use-cases/job-posting/managing-job-ads/previewing-a-job-ad': {
    toc: UseCasesJobPostingManagingJobAdsPreviewingAJobAdTableOfContents,
    document: UseCasesJobPostingManagingJobAdsPreviewingAJobAd,
  },
  '/use-cases/job-posting/managing-job-ads/querying-a-job-ad': {
    toc: UseCasesJobPostingManagingJobAdsQueryingAJobAdTableOfContents,
    document: UseCasesJobPostingManagingJobAdsQueryingAJobAd,
  },
  '/use-cases/job-posting/managing-job-ads/updating-a-job-ad': {
    toc: UseCasesJobPostingManagingJobAdsUpdatingAJobAdTableOfContents,
    document: UseCasesJobPostingManagingJobAdsUpdatingAJobAd,
  },
  '/use-cases/job-posting/managing-job-ads': {
    toc: UseCasesJobPostingManagingJobAdsTableOfContents,
    document: UseCasesJobPostingManagingJobAds,
  },
  '/use-cases/job-posting/position-openings': {
    toc: UseCasesJobPostingPositionOpeningsTableOfContents,
    document: UseCasesJobPostingPositionOpenings,
  },
  '/use-cases/job-posting/questionnaires/ats-questions': {
    toc: UseCasesJobPostingQuestionnairesAtsQuestionsTableOfContents,
    document: UseCasesJobPostingQuestionnairesAtsQuestions,
  },
  '/use-cases/job-posting/questionnaires/custom-panel': {
    toc: UseCasesJobPostingQuestionnairesCustomPanelTableOfContents,
    document: UseCasesJobPostingQuestionnairesCustomPanel,
  },
  '/use-cases/job-posting/questionnaires/panel': {
    toc: UseCasesJobPostingQuestionnairesPanelTableOfContents,
    document: UseCasesJobPostingQuestionnairesPanel,
  },
  '/use-cases/job-posting/questionnaires/v2/panel': {
    toc: UseCasesJobPostingQuestionnairesV2PanelTableOfContents,
    document: UseCasesJobPostingQuestionnairesV2Panel,
  },
  '/use-cases/job-posting/questionnaires': {
    toc: UseCasesJobPostingQuestionnairesTableOfContents,
    document: UseCasesJobPostingQuestionnaires,
  },
  '/use-cases/job-posting/reflecting-job-ads': {
    toc: UseCasesJobPostingReflectingJobAdsTableOfContents,
    document: UseCasesJobPostingReflectingJobAds,
  },
  '/use-cases/job-posting/salary': {
    toc: UseCasesJobPostingSalaryTableOfContents,
    document: UseCasesJobPostingSalary,
  },
  '/use-cases/job-posting/user-experience-guide': {
    toc: UseCasesJobPostingUserExperienceGuideTableOfContents,
    document: UseCasesJobPostingUserExperienceGuide,
  },
  '/use-cases/job-posting': {
    toc: UseCasesJobPostingTableOfContents,
    document: UseCasesJobPosting,
  },
  '/use-cases/proactive-sourcing/interaction-history': {
    toc: UseCasesProactiveSourcingInteractionHistoryTableOfContents,
    document: UseCasesProactiveSourcingInteractionHistory,
  },
  '/use-cases/proactive-sourcing/profile-purchases': {
    toc: UseCasesProactiveSourcingProfilePurchasesTableOfContents,
    document: UseCasesProactiveSourcingProfilePurchases,
  },
  '/use-cases/proactive-sourcing/sharing-a-candidate': {
    toc: UseCasesProactiveSourcingSharingACandidateTableOfContents,
    document: UseCasesProactiveSourcingSharingACandidate,
  },
  '/use-cases/proactive-sourcing/unposted-positions': {
    toc: UseCasesProactiveSourcingUnpostedPositionsTableOfContents,
    document: UseCasesProactiveSourcingUnpostedPositions,
  },
  '/use-cases/proactive-sourcing/widgets': {
    toc: UseCasesProactiveSourcingWidgetsTableOfContents,
    document: UseCasesProactiveSourcingWidgets,
  },
  '/use-cases/proactive-sourcing': {
    toc: UseCasesProactiveSourcingTableOfContents,
    document: UseCasesProactiveSourcing,
  },
  '/use-cases/test-cases': {
    toc: UseCasesTestCasesTableOfContents,
    document: UseCasesTestCases,
  },
};

export const tsxComponents: Record<string, TemplateComponent> = {
  '/': Home,
  '/introduction/release-notes': IntroductionReleaseNotes,
};
